import { Routes, Router } from '@angular/router';
import { isPlatformServer } from '@angular/common';
const ɵ0 = () => import("./not-found/not-found.module.ngfactory").then(mod => mod.NotFoundModuleNgFactory), ɵ1 = () => import("./web-generator/web-generator.module.ngfactory").then(mod => mod.WebGeneratorModuleNgFactory), ɵ2 = () => import("./not-found/not-found.module.ngfactory").then(mod => mod.NotFoundModuleNgFactory);
const routes = [
    { path: '404', loadChildren: ɵ0 },
    { path: ':lang', loadChildren: ɵ1 },
    { path: '**', loadChildren: ɵ2 },
];
export class AppRoutingModule {
    constructor(platformId, response, router) {
        this.platformId = platformId;
        this.response = response;
        this.router = router;
        this.router.errorHandler = (error) => {
            if (isPlatformServer(this.platformId)) {
                this.response.status(404);
            }
            else {
                this.router.navigate(['404']); // or redirect to default route
            }
        };
    }
}
export { ɵ0, ɵ1, ɵ2 };
